import token, { tokenToVars } from '../token';
import Skeleton from './skeleton';

export { Skeleton };
export default tokenToVars(Skeleton, token);
